import React from "react";
import { FaCalendarAlt, FaBuilding } from "react-icons/fa";
import Edit from "../action/Edit";
import Hapus from "../action/Hapus";
import ViewFoto from "./ViewFoto";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
// Import PrimeReact CSS
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';

function DataPerawatan({
  currentData,
  handleView,
  handleDelete,
  handleEdit,
  getStatusBadge,
  loading = false
}) {
  return (
    <>
      <DataTable
        value={currentData}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Menampilkan {first} sampai {last} dari {totalRecords} data"
        emptyMessage="Tidak ada data perawatan aset yang tersedia"
        loading={loading}
        stripedRows
        showGridlines
        responsiveLayout="scroll"
        className="p-datatable-sm"
      >
        {/* Template untuk Aset */}
        <Column 
          field="inventaris_desc" 
          header="Aset" 
          body={(rowData) => (
            <div className="flex flex-col">
              <div className="text-sm font-medium text-gray-900">
                {rowData.inventaris_desc || "N/A"}
              </div>
              <div className="text-sm text-gray-500">
                {rowData.kode || "N/A"}
              </div>
            </div>
          )}
          style={{ minWidth: '200px' }}
          sortable
        />

        <Column
          field="gedung"
          header="Lokasi Gedung"
          body={(rowData) => (
            <div className="flex items-start gap-2">
              <FaBuilding className="mt-0.5 w-4 h-4 shrink-0 text-gray-400" />
              <div className="flex flex-col">
                <span className="text-sm font-medium text-gray-900">
                  {rowData.gedung ? `Gedung ${rowData.gedung}` : "-"}
                </span>
                {rowData.ruang && (
                  <span className="text-xs text-gray-500">{rowData.ruang}</span>
                )}
              </div>
            </div>
          )}
          style={{ minWidth: "160px" }}
          sortable
        />

        {/* Template untuk Jenis Kerusakan */}
        <Column 
          field="jenis_kerusakan" 
          header="Jenis Kerusakan" 
          style={{ minWidth: '150px' }}
          sortable
        />

        {/* Template untuk Tanggal Pelaporan */}
        <Column 
          field="tgl_masuk" 
          header="Tanggal Pelaporan" 
          body={(rowData) => (
            <div className="flex items-center gap-2">
              <FaCalendarAlt className="w-4 h-4 text-gray-400" />
              <span className="text-sm text-gray-900">
                {rowData.tgl_masuk
                  ? new Date(rowData.tgl_masuk).toLocaleDateString("id-ID")
                  : "N/A"}
              </span>
            </div>
          )}
          style={{ minWidth: '180px' }}
          sortable
        />

        {/* Template untuk Teknisi */}
        <Column 
          field="pic" 
          header="Teknisi" 
          style={{ minWidth: '120px' }}
          sortable
        />

        {/* Template untuk Status */}
        <Column 
          field="status" 
          header="Status" 
          body={(rowData) => getStatusBadge(rowData.status)}
          style={{ minWidth: '148px' }}
          sortable
        />

        {/* Template untuk Tanggal Selesai */}
        <Column 
          field="tgl_selesai" 
          header="Tanggal Selesai" 
          body={(rowData) => (
            <div className="flex items-center gap-2">
              <FaCalendarAlt className="w-4 h-4 text-gray-400" />
              <span className="text-sm text-gray-900">
                {rowData.tgl_selesai
                  ? new Date(rowData.tgl_selesai).toLocaleDateString("id-ID")
                  : "N/A"}
              </span>
            </div>
          )}
          style={{ minWidth: '180px' }}
          sortable
        />

        {/* Template untuk Foto */}
        <Column 
          field="foto" 
          header="Foto" 
          body={(rowData) => <ViewFoto foto={rowData.foto} />}
          style={{ minWidth: '100px', textAlign: 'center' }}
          sortable={false}
        />

        {/* Template untuk Aksi */}
        <Column 
          field="id" 
          header="Aksi" 
          body={(rowData) => (
            <div className="flex items-center gap-2">
              <Edit id={rowData.id} handleEdit={handleEdit} />
              <Hapus id={rowData.id} handleDelete={handleDelete} />
            </div>
          )}
          style={{ minWidth: '100px', textAlign: 'center' }}
          sortable={false}
        />
      </DataTable>
    </>
  );
}

export default DataPerawatan;
